// @flow
import React, {useMemo} from 'react';
import Box from "@mui/material/Box";
import useUserData from "../../../../../../../hooks/user/useUserData";
import {muiGridLocales} from "../../../../../../../helpers/muiGridLocales";
import {DataGridPremium, GridToolbar, useGridApiRef, useKeepGroupedColumnsHidden} from "@mui/x-data-grid-premium";
import {formatDate} from "../../../../../../../helpers/date";
import _ from "lodash";
import { reportGridsSx } from "../../helpers";

type Props = {};

const InterestStatistics = (props: Props) => {
	const {loading, data, t, generalReport} = props
	const {language, dateFormat} = useUserData()
	const report = useMemo(() => (
		_.orderBy(data, ['exhibitionStartDt', 'category'], ['desc', 'asc'])
	), [data])
	
	
	const apiRef = useGridApiRef();
	const initialState = useKeepGroupedColumnsHidden({
		apiRef,
		initialState: {
			density: "standard",
			rowGrouping: {
				model: generalReport ? ['groupingColumn'] : ['exhibitionStartDt']
			}
		},
	});
	
	const columns = useMemo(() => [
			...(generalReport ? [{
				field: 'groupingColumn',
				description: t('Exhibition'),
				headerName: t('Exhibition'),
				width: 800,
			}] : []),
			...(!generalReport ? [{
				field: 'exhibitionStartDt',
				description: t('Exhibition Date'),
				headerName: t('Exhibition Date'),
				width: 400,
				valueFormatter: (value, row, column, apiRef) => {
					return `${formatDate(value, dateFormat)}`
				}
			}] : []),
			{
				field: 'category',
				description: t('Description'),
				headerName: t('Description'),
				flex: 1,
				minWidth: 200,
			},
			{
				field: 'visitorCount',
				description: t('VisitorCount'),
				headerName: t('VisitorCount'),
				flex: 1,
				type: 'number',
			},
			{
				field: 'visitorPercentage',
				description: t('VisitorPercentage_info'),
				headerName: t('VisitorPercentage'),
				flex: 1,
				minWidth: 200,
				type: 'number',
			},
		],
		[dateFormat, generalReport, t]
	)
	
	return (
		<Box style={{height: 600, width: '100%'}}>
			<DataGridPremium
				apiRef={apiRef}
				sx={reportGridsSx}
				loading={loading}
				initialState={initialState}
				localeText={muiGridLocales(language)}
				rows={report}
				columns={columns}
				slots={{
					toolbar: GridToolbar
				}}
				slotProps={{toolbar: {csvOptions: {disableToolbarButton: true}}}}
				defaultGroupingExpansionDepth={-1}
			/>
		</Box>
	);
};

export default InterestStatistics